<!-- eslint-disable -->
<template lang="pug">
    .draw
        .draw__clevik
            img(src="../../../assets/images/battles/result/victory-clevik.png")
        .draw-box
            .draw__title {{ $i18n.t('battle.battle_draw_title') }}
            .draw__text {{ $i18n.t('battle.battle_try_more') }}
            .draw__buttons
                cs-button(
                    type="button",
                    color="blue",
                    @click="$router.push({name: playMoreRouteString})"
                ) {{ $i18n.t('battle.battle_play_more_time') }}
                cs-button(
                    type="button",
                    color="blue",
                    pattern="primary-outline",
                    @click="$emit('showResultStats')"
                ) {{ $i18n.t('battle.battle_view_stats') }}
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            playMoreRouteString: {
                type: String,
                default: ''
            }
        }
    }
</script>

<style scoped lang="scss">
    .draw {
        margin: 30px 0;
        text-align: center;
        color: #333333;
    }
    .draw__clevik {
        height: 185px;
    }
    .draw-box {
        background: #F7F7FF;
        border-radius: 20px;
        white-space: nowrap;
        max-width: 460px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 25px 125px 30px 125px;
        @media screen and (max-width: 576px) {
          padding: 25px 55px 30px 55px;
        }
        @media screen and (max-width: 576px) {
          padding: 25px 30px 30px 30px;
        }
    }
    .draw__title {
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 5px;
    }
    .draw__text {
        font-size: 16px;
        line-height: 30px;
        margin-bottom: 10px;
    }
    .draw__buttons {
        display: flex;
        flex-direction: column;
        @include media($md) {
            flex-direction: row;
            justify-content: center;
        }
    }
    .draw__buttons .cs-button:nth-child(2) {
        margin: 20px 0 0 0;
        @include media($md) {
            margin: 0 0 0 20px;
        }
    }
</style>
